import cr from '@/locales/cr'
import gt from '@/locales/gt'
import hn from '@/locales/hn'
import ni from '@/locales/ni'
import sv from '@/locales/sv'

export default {
  cr,
  gt,
  hn,
  ni,
  sv
}
